import portalRequest from './request';

/**
 * 检查用户是否有有效的品牌资料套餐
 * 根据后端返回的 packageExpireTime 判断
 */
export async function hasActivePortalBrandPackage(): Promise<boolean> {
  try {
    const res: any = await portalRequest({
      url: '/api/portal/user/profile',
      method: 'get'
    });
    
    if (res.code === 200 && res.data) {
      const packageExpireTime = res.data.packageExpireTime;
      
      // 如果没有过期时间，返回false
      if (!packageExpireTime) {
        return false;
      }
      
      // 判断是否过期（小于当前时间）
      const expireDate = new Date(packageExpireTime);
      const now = new Date();
      
      return expireDate > now;
    }
    
    return false;
  } catch (e) {
    console.error('获取用户套餐信息失败', e);
    return false;
  }
}

/**
 * 清除缓存，强制下次重新查询
 * （用于登出、支付成功等场景）
 */
export function clearPackageCache() {
  // 此函数保留以保持API完整性，但实际上每次都是实时查询
  // 如果未来需要添加缓存机制，可以在这里清除
  console.log('套餐缓存已清除');
}

